<template>
    <div class="chat">
        Chat
    </div>
</template>

<script>
    export default {
        name: 'Chat',
        data() {
            return {
               
            }   
        },
        methods: {
            
        },
        mounted: function() {

        }
    }
</script>

<style scoped lang="less">
    .chat{
        padding: 20px 24px;
        
    }
</style>